<template>
    <section class="how-it-works">
        <div class="container container--mw-xxl">
            <div class="row justify-content-between flex-lg-row-reverse align-items-center">
                <div class="col-12 col-lg-5">
                    <h2 class="how-it-works__heading">HOW DOES IT WORK?</h2>

                    <p class="how-it-works__copy">End to end brand name creation, checking and testing.</p>
                </div>

                <div class="col-12 col-md-6 col-lg-5">
                    <HowBlock :heading="'1'">
                        <p class="body-copy body-copy--align-center">Use the <span class="fw-500">CREATE</span> function to help inspire you as you develop your new brand name.</p>
                    </HowBlock>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-md-6 col-lg-5">
                    <HowBlock :heading="'2'">
                        <p class="body-copy body-copy--align-center">Use the <span class="fw-500">CHECK</span> function to see if anyone else has secured your brand name (trademarks, domain names and social handles).</p>
                    </HowBlock>
                </div>
            </div>

            <div class="row justify-content-end">
                <div class="col-12 col-md-6 col-lg-5">
                    <HowBlock :heading="'3'">
                        <p class="body-copy body-copy--align-center body-copy--fw-700">COMING SOON...<br><br></p>
                        <p class="body-copy body-copy--align-center">Use the <span class="fw-500">TEST</span> function to see how your brand name resonates with a test panel.</p>
                    </HowBlock>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import HowBlock from "@/views/HomePage/HowBlock";

    export default {
        name: 'HowItWorks',
        components: {
            HowBlock,
        }
    }
</script>